<div class="modal-content">

    <!-- Fixed title (outside the scroll area) -->
    <h2 class="orange-text font-bold text-2xl px-8 pt-7 pb-3">{{ title }}</h2>

    <!-- Scrolling body -->
    <div class="modal-body px-8 pb-6">
        <form *ngIf="form" [formGroup]="form" class="flex flex-col gap-4 flex-1">

            <!-- Row 1: Title | Placement -->
            <div class="grid grid-cols-2 gap-4">

                <div class="flex flex-col gap-1">
                    <span class="text-xs font-bold">Title: <span class="text-red-500">*</span></span>
                    <div class="card-input flex items-center text-xs py-2" [class.has-error]="errors.title" appHighlightOnActive="true">
                        <input formControlName="title" type="text" placeholder="Enter Title"
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic">
                    </div>
                    <span *ngIf="errors.title" class="error-text">{{ errors.title }}</span>
                </div>

                <div class="flex flex-col gap-1">
                    <span class="text-xs font-bold">Placement: <span class="text-red-500">*</span></span>
                    <app-custom-dropdown-v2
                        [options]="placementOptions"
                        [selectedText]="placementText"
                        placeholder="Select an Option"
                        [hasError]="!!errors.placement"
                        [class.dropdown-error]="errors.placement"
                        (selectionChange)="setPlacement($event.value)">
                    </app-custom-dropdown-v2>
                    <span *ngIf="errors.placement" class="error-text">{{ errors.placement }}</span>
                </div>

            </div>

            <!-- Row 2: Details -->
            <div class="flex flex-col gap-1">
                <span class="text-xs font-bold">Details: <span class="text-red-500">*</span></span>
                <div class="card-input flex items-start text-xs py-2 w-full" appHighlightOnActive="true" [class.has-error]="errors.description">
                    <textarea
                        formControlName="description"
                        [placeholder]="'Enter Details ( Maximum of ' + descriptionMaxLength + ' characters )'"
                        [attr.maxlength]="descriptionMaxLength"
                        rows="3"
                        class="placeholder-black focus:outline-none w-full bg-gray-100 rounded-md px-3 py-2 resize-none italic"
                        style="height: 70px;"
                    ></textarea>
                </div>
                <span *ngIf="errors.description" class="error-text">{{ errors.description }}</span>
            </div>

            <!-- Row 3: Image -->
            <div class="flex flex-col gap-1">
                <span class="text-xs font-bold">Image:
                    <span class="text-black text-xs font-normal italic">(Image dimension size: {{ adImageRules.minHeight }}px (min) – {{ adImageRules.maxHeight }}px (max))</span>
                    <span class="text-red-500">* </span>
                </span>
                <input type="file" class="hidden" (change)="onSelectFile($event)" #featuredImg [accept]="acceptedImageTypes">

                <div class="image-dropzone flex items-center gap-4 text-xs" [class.has-error]="errors.image"
                     [class.dragging]="isDragging"
                     (dragover)="onDragOver($event)"
                     (dragleave)="onDragLeave($event)"
                     (drop)="onDrop($event)">
                    <button type="button" class="browse-btn px-4 py-2 focus:outline-none whitespace-nowrap font-bold" (click)="featuredImg.click()">
                        {{ featured_img ? 'Replace Image...' : 'Browse...' }}
                    </button>
                    <span class="italic text-xs truncate min-w-0">
                        {{ isDragging ? 'Drop image here' : (featured_img ? imageName : 'No file selected (Maximum image file size: 5mb)') }}
                    </span>
                </div>
                <span *ngIf="errors.image" class="error-text">{{ errors.image }}</span>
                <div class="image-preview mt-2" *ngIf="featured_img" [style.aspect-ratio]="previewAspectRatio">
                    <img [src]="featured_img" alt="Ad preview">
                </div>
            </div>

            <!-- Row 4: Date From | Date To -->
            <div class="grid grid-cols-2 gap-4">
                <div class="flex flex-col gap-1">
                    <span class="text-xs font-bold">Date From: <span class="text-red-500">*</span></span>
                    <div class="card-input flex items-center text-xs py-2 w-full" appHighlightOnActive="true" [class.has-error]="errors.dateFrom">
                        <app-date-input
                            class="w-full"
                            [parentForm]="form"
                            controlName="dateFrom"
                            [min]="null"
                        >
                        </app-date-input>
                    </div>
                    <span *ngIf="errors.dateFrom" class="error-text">{{ errors.dateFrom }}</span>
                </div>
                <div class="flex flex-col gap-1">
                    <span class="text-xs font-bold">Date To: <span class="text-red-500">*</span></span>
                    <div class="card-input flex items-center text-xs py-2 w-full" (click)="onDateToContainerClick()" appHighlightOnActive="true" [class.has-error]="errors.dateTo">
                        <app-date-input
                            class="w-full"
                            [parentForm]="form"
                            controlName="dateTo"
                            [min]="minDateTo">
                        </app-date-input>
                    </div>
                    <span *ngIf="errors.dateTo" class="error-text">{{ errors.dateTo }}</span>
                </div>
            </div>

            <!-- Row 5: Redirect to (screen) / Link  |  Duration -->
            <div class="grid grid-cols-2 gap-4">

                <div *ngIf="adType === 'screen'" class="flex flex-col gap-1">
                    <span class="text-xs font-bold">Redirect to: <span class="text-red-500">*</span></span>
                    <app-custom-dropdown-v2
                        [options]="screenOptions"
                        [selectedText]="screen_text || ''"
                        placeholder="Select an Option"
                        [direction]="'down'"
                        [hasError]="!!errors.screen"
                        [class.dropdown-error]="errors.screen"
                        (selectionChange)="setScreen($event.label, $event.value)">
                    </app-custom-dropdown-v2>
                    <span *ngIf="errors.screen" class="error-text">{{ errors.screen }}</span>
                </div>

                <div *ngIf="adType === 'link'" class="flex flex-col gap-1">
                    <span class="text-xs font-bold">Link: <span class="text-red-500">*</span></span>
                    <div class="card-input flex items-center text-xs py-2" appHighlightOnActive="true" [class.has-error]="errors.link">
                        <input
                            formControlName="link"
                            type="text"
                            placeholder="Enter URL (e.g., https://example.com)"
                            [class.border-red-500]="form.get('link')!.invalid && form.get('link')!.touched"
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic">
                    </div>
                    <span *ngIf="errors.link" class="error-text">{{ errors.link }}</span>
                </div>

                <div class="flex flex-col gap-1">
                    <span class="text-xs font-bold">Duration (in seconds): <span class="text-red-500">*</span></span>
                    <div class="card-input flex items-center text-xs py-2" appHighlightOnActive="true" [class.has-error]="errors.duration">
                        <input
                            formControlName="duration"
                            type="number"
                            placeholder="Duration"
                            min="1"
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic">
                    </div>
                    <span *ngIf="errors.duration" class="error-text">{{ errors.duration }}</span>
                </div>

            </div>

            <!-- Buttons (centered; follow the content, sit at the bottom when there's spare height) -->
            <div class="flex items-center justify-center gap-3 mt-auto pt-3">
                <button
                    type="button"
                    (click)="close()"
                    class="uppercase custom-btn btn-light-orange font-bold text-xs px-8 py-2"
                >
                    CANCEL
                </button>
                <button
                    type="button"
                    (click)="submit()"
                    [disabled]="isSubmitting"
                    class="uppercase custom-btn btn-dark-orange font-bold text-xs px-8 py-2"
                >
                    UPLOAD
                </button>
            </div>

        </form>
    </div>
</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>